import { Component, ElementRef, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { PaginationService } from 'src/app/PaginationService';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PopupData } from '../tms-groups.component';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { EditorComponent } from 'src/app/editor/editor.component';
@Component({
  selector: 'app-tms-group-trainings',
  templateUrl: './tms-group-trainings.component.html',
  styleUrls: ['./tms-group-trainings.component.scss']
})
export class TmsGroupTrainingsComponent implements OnInit {

  @Input() trainingGroupdata: any = {};
  searchText: any;
  searchValue: any;
  isProcessing = true;
  _temp: any = {};
  columnLists: any = {};
  trainingGroupTrainingsDataForGrid: any = [];
  makeStickyColumns: any;
  dataTypeList: any = [];

  auditTrail: any = {};
  visibleAuditTrail: boolean = false;
  oddTrainingLevel: any = null;
  oddTrainingTemplate: any = null;
  oddRepeatIntervalUnit: any = null;

  constructor(public dialog: MatDialog, readonly appService: AppService, public router: Router, readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, readonly elem: ElementRef) { }


  visibleDataGrid: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages

  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  readonly users: any[];
  pager: any = {};
  pagedItems: any[];
  error = '';
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.trainingGroupTrainingsDataForGrid.length, page, this.perPage, targetpage);
    this.pagedItems = this.trainingGroupTrainingsDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  getcallMethod() {
    this.trainingGroupTrainingsDataForGrid = [];
    const data = {

      gridName: "GROUP_TRAININGS"
    }
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        // 1. Prepare Configuration
        response.orderByClause = response.orderByClause ?? "";
        this.makeStickyColumns = response.fixedFieldCnt;

        const data1: any = {

          gridName: "GROUP_TRAININGS_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          groupId: this.trainingGroupdata.groupId.toString(),
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist ?? "",
          blobColumnlist: response.bloblist ?? ""
        };

        this.reportObj = { ...data1, ...data };

        // 2. Fetch Grid Data
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.trainingGroupTrainingsDataForGrid = response1;
            this.visibleAuditTrail = false;

            // Parse raw strings into arrays
            data1.columnsListarray = data1.columnsList.split(",");
            const rawLabels = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            const rawSizes = data1.fieldSizeList.split(",");

            // 3. Filter Columns (Replacing the buggy splice loop)
            // We rebuild the lists excluding items found in invisibleColumnarray
            const validColumns = [];
            const validLabels = [];
            const validSizes = [];

            // Note: Using standard loop here to keep the 3 parallel arrays (Cols, Labels, Sizes) in sync
            for (let i = 0; i < data1.columnsListarray.length; i++) {
              const colName = data1.columnsListarray[i];

              // Only add if NOT invisible
              if (!data1.invisibleColumnarray.includes(colName)) {
                validColumns.push(colName);

                validLabels.push({
                  fieldColumnarray: rawLabels[i],
                  width: (rawSizes[i] ?? '0') + 'px'
                });

                validSizes.push((rawSizes[i] ?? '0') + 'px');
              }
            }

            // Assign filtered lists
            this.columnLists.columnsListarray = validColumns;
            this.columnLists.fieldColumnarray = validLabels;
            this.columnLists.fieldSizeListArray = validSizes;
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;

            const tableData = {
              tablename: data1.tableOrViewName
            };

            this.columnLists.columnsListarray1 = [];

            // 4. Fetch Data Types
            this.appService.tableFieldsDataType(tableData).subscribe({
              next: (response2: any) => {
                this.dataTypeList = response2;

                // Map Data Types (Using for...of)
                for (const colName of this.columnLists.columnsListarray) {
                  let currentType = "textbox";

                  // Find matching type
                  for (const typeItem of this.dataTypeList) {
                    if (typeItem.columnName === colName) {
                      currentType = typeItem.fieldType;
                      break;
                    }
                  }

                  this.columnLists.columnsListarray1.push({
                    columnsListarray: colName,
                    dataType: currentType,
                    width: this.columnLists.fieldSizeListArray
                  });
                }

                // Convert Checkboxes (Using for...of)
                for (const row of this.trainingGroupTrainingsDataForGrid) {
                  for (const typeItem of this.dataTypeList) {
                    if (typeItem.fieldType === 'CHECKBOX') {
                      // Convert "Y" to true, else false
                      row[typeItem.columnName] = row[typeItem.columnName] === "Y";
                    }
                  }
                }

                // Pagination Setup
                this.calculateTotalPages = this.collectionSize / this.perPage;
                this.pager.totalPages = undefined;
                this.setPage(1, 0);

                // Final Assignments
                this.message.gridList = this.trainingGroupTrainingsDataForGrid;
                this.collectionSize = this.trainingGroupTrainingsDataForGrid.length;
                this.totalPages = Math.ceil(this.trainingGroupTrainingsDataForGrid.length / this.itemsPerPage);
                this.dynamicLabelCall();
                this.isProcessing = false;
              },
              error: (error) => {
                this.isProcessing = false;
                throw error;
              }
            });
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });

        this.isProcessing = false;
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });

  }
  dropDownForCategories: any = [];
  dropDownForLangauge: any = [];
  dropdownForTemplates: any = [];
  getListOfQaUsersList: any = [];
  ngOnInit() {
    this.appService.getCategoriesList().subscribe((data: any) => {
      this.dropDownForCategories = data;
      this.selectBoxeForCategory();
    })
    this.appService.getCodeListsByGroup("TRAINING_LANGUAGE").subscribe((data: any) => {
      this.dropDownForLangauge = data;
      this.selectBoxeForLanguage();
    })

    this.appService.getTmsQAUserList().subscribe((data: any) => {
      this.getListOfQaUsersList = data;
      this.selectBoxForQaUsers();
    })
    this.appService.getCodeListsByGroup("REPEAT_INTERVAL_UNIT").subscribe((data: any) => {
      this.dropDownDataForRepeatIntervalUnit = data;
      this.selectBoxForRepeatIntervalUnit();
    })

    this.appService.getTmsTrainingParameterTemplateVwDetails()
      .subscribe({
        next: (data: any) => {
          this.dropdownForTemplates = data;

          for (const template of this.dropdownForTemplates) {
            this.trainingTemplateDropdown.push({
              valueExp: template.templateId,
              displayExp: template.templateName
            });
          }
        },
        error: (error) => {
          console.error(error);
        }
      });

    for (const level of this.trainingLevelList) {
      this.trainingLevelDropdown.push({
        valueExp: level,
        displayExp: level
      });
    }

    this.getcallMethod();
  }


  selectedRepeatIntervalUnit: any = null;
  selectedRepeatIntervalUnitDisplayExp: any = null;
  selectedRepeatIntervalUnitValueExp: any = [];
  repeatIntervalUnitDropdown: any = [];
  dropDownDataForRepeatIntervalUnit: any = [];

  selectBoxForRepeatIntervalUnit() {
    for (const item of this.dropDownDataForRepeatIntervalUnit) {
      this.repeatIntervalUnitDropdown.push({
        valueExp: item.codelistCode,
        displayExp: item.codelistName
      });
    }
  }

  repeatIntervalUnitsearchTxt: any;
  onRepeatIntervalUnitSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedRepeatIntervalUnit = item.valueExp;
        this.selectedRepeatIntervalUnitDisplayExp = item.valueExp;
      }
    }
  }


  onRepeatIntervalUnitSelectOld(item: any) {
    this.selectedRepeatIntervalUnitDisplayExp = item.displayExp;
  }

  onRepeatIntervalUnitRemoved(item: any) { }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filter === '') {
      this.pagedItems = this.trainingGroupTrainingsDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.trainingGroupTrainingsDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)

      );
    }
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }

      index1++;
    })


    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }

    })
  }

  onClick(event: any) {
  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  dataGridParentCheckBoxChecked(e: any) {
    const isChecked = e.target.checked;
    this.childCheckBoxs = isChecked;

    for (const row of this.trainingGroupTrainingsDataForGrid) {
      row.childCheckBoxs = isChecked;
    }
  }

  priviousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.priviousSelectedValue != undefined) {
        this.trainingGroupTrainingsDataForGrid[this.priviousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.GROUP_TRAINING_ID;
    } else {
      list.childCheckBoxs = false;
    }
    this.priviousSelectedValue = idx;
    this.visibleAuditTrail = this.trainingGroupTrainingsDataForGrid.some((list: any) => list.childCheckBoxs);
  }

  validateNumberFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  multipleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
  };

  trainingName: any;
  trainingLevel: any;
  listOfQAUsers: any;
  trainingNameRequiredMsg: any;
  trainingLevelRequiredMsg: any;
  listOfQAUsersRequiredMsg: any;
  updateReason: HTMLInputElement | null = null;
  updateReasonRequiredMsg: HTMLInputElement | null = null;

  fieldValidation(): boolean {
    let isFormValid = true;

    this.trainingName = document.getElementById('trainingName') as HTMLInputElement;
    this.trainingNameRequiredMsg = document.getElementById('trainingName-required-msg') as HTMLInputElement;

    if (this.trainingGroupTrainingFieldData.trainingName) {
      this.setFieldValid(this.trainingName, this.trainingNameRequiredMsg);
    } else {
      this.setFieldInvalid(this.trainingName, this.trainingNameRequiredMsg);
      isFormValid = false;
    }

    this.trainingLevel = document.getElementById('trainingLevel') as HTMLInputElement;
    this.trainingLevelRequiredMsg = document.getElementById('trainingLevel-required-msg') as HTMLInputElement;

    if (this.selectedLevelValue) {
      this.setFieldValid(this.trainingLevel, this.trainingLevelRequiredMsg);
    } else {
      this.setFieldInvalid(this.trainingLevel, this.trainingLevelRequiredMsg);
      isFormValid = false;
    }

    if (this.trainingGroupTrainingFieldData.overdueQaApprovalReqd) {
      this.listOfQAUsers = document.getElementById('listOfQAUsers') as HTMLInputElement;
      this.listOfQAUsersRequiredMsg = document.getElementById('listOfQAUsers-required-msg') as HTMLInputElement;

      if (this.selectedQaUsers.length >= 1) {
        this.setFieldValid(this.listOfQAUsers, this.listOfQAUsersRequiredMsg, '1px solid black');
      } else {
        this.setFieldInvalid(this.listOfQAUsers, this.listOfQAUsersRequiredMsg);
        isFormValid = false;
      }
    }
    if (this.operationFlag === 'EDIT') {
      this.updateReason = document.getElementById('updateReason') as HTMLInputElement;
      this.updateReasonRequiredMsg = document.getElementById('updateReason-required-msg') as HTMLInputElement;

      if (this.trainingGroupTrainingFieldData.updateReason) {
        this.setFieldValid(this.updateReason, this.updateReasonRequiredMsg);
      } else {
        this.setFieldInvalid(this.updateReason, this.updateReasonRequiredMsg);
        isFormValid = false;
      }
    }

    return isFormValid;
  }

  /**
   * Handle Valid State (Green/Clear path)
   */
  private setFieldValid(inputEl: HTMLElement | null, msgEl: HTMLElement | null, borderStyle: string = 'none') {
    if (inputEl) inputEl.style.border = borderStyle;
    if (msgEl) msgEl.style.display = 'none';
  }
  /**
   * Handle Invalid State (Red/Error path)
   */
  private setFieldInvalid(inputEl: HTMLElement | null, msgEl: HTMLElement | null) {
    if (inputEl) inputEl.style.border = '1px solid red';
    if (msgEl) msgEl.style.display = 'block';
  }

  trainingGroupTrainingFieldData: any = {};
  operationFlag: any;
  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  @ViewChild('searchTraining', { static: true }) searchTraining: TemplateRef<any>;
  @ViewChild('trainingGroupActiveInactivePopup', { static: true }) trainingGroupActiveInactivePopup: TemplateRef<any>;

  visibleSearchTrainingPopup: MatDialogRef<TemplateRef<any>>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  visibleTrainingGroupActiveInactivePopup: MatDialogRef<TemplateRef<any>>;

  searchTrainingConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  trainingGroupActiveInactivePopupConfig = {
    width: '35%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  visibleReasonForUpdateField: boolean;
  openAddPopup() {
    this.oddTrainingLevel = null;
    this.oddTrainingTemplate = null;
    this.oddRepeatIntervalUnit = null;
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.visibleReasonForUpdateField = false;
    this.operationFlag = 'ADD';
    this.popupDataTitle.title = "Create Group Training";
    this.trainingGroupTrainingFieldData.trainingId = '';
    this.trainingGroupTrainingFieldData.trainingName = null;
    this.trainingGroupTrainingFieldData.groupId = null;
    this.trainingGroupTrainingFieldData.groupTrainingId = null;
    this.trainingGroupTrainingFieldData.version = false;
    this.trainingGroupTrainingFieldData.trainingLevel = null;
    this.trainingGroupTrainingFieldData.dueNDayFromAssigned = null;
    this.trainingGroupTrainingFieldData.remindNDayBeforeDue = null;
    this.trainingGroupTrainingFieldData.escalate = false;
    this.trainingGroupTrainingFieldData.remindEveryNDays = null;
    this.trainingGroupTrainingFieldData.escalateEveryNDays = null;
    this.trainingGroupTrainingFieldData.repeatTraining = false;
    this.trainingGroupTrainingFieldData.repeatInterval = null;
    this.trainingGroupTrainingFieldData.repeatIntervalUnit = null;
    this.trainingGroupTrainingFieldData.allowedFailedAttempts = null;
    this.trainingGroupTrainingFieldData.allowedFailedAttemptsAfterUnlock = null;
    this.trainingGroupTrainingFieldData.maxAllowedFailedAttempts = null;
    this.trainingGroupTrainingFieldData.allowToReviewResults = false;
    this.trainingGroupTrainingFieldData.showAnswersAtReview = false;
    this.trainingGroupTrainingFieldData.overdueRmApprovalReqd = false;
    this.trainingGroupTrainingFieldData.overdueQaApprovalReqd = false;
    this.trainingGroupTrainingFieldData.listOfQaUsers = null;
    this.trainingGroupTrainingFieldData.dueNDayFromOverdueUnlock = null;
    this.trainingGroupTrainingFieldData.retakeAfterNMinOnFailedAttempt = null;
    this.selectedRepeatIntervalUnit = null;
    this.selectedTrainingTemplate = null;
    this.selectedTrainingLevel = this.trainingLevelList[0];
    this.selectedLevelValue = 1;
    this.selectedRepeatIntervalUnitDisplayExp = null;
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  previousData: any;
  getTmsGroupTrainingsVwData: any = [];
  filteredRepeatIntervalUnit: any;


  openEditPopup(editRowData: any) {
    this.isProcessing = true;
    this.previousData = editRowData;
    this.trainingGroupTrainingFieldData.updateReason = null;
    if (this.previousData.IS_ACTIVE) {
      this.visibleEditButton = true;
    } else {
      this.visibleEditButton = false;
    }
    this.trainingGroupTrainingFieldData.updateReason = '';
    this.operationFlag = 'EDIT';
    this.visibleAddButton = false;
    this.visibleReasonForUpdateField = true;
    this.operationFlag = 'EDIT';
    this.popupDataTitle.title = "Update Group Training";
    this.appService.getTmsGroupTrainingDetail(editRowData.GROUP_TRAINING_ID).subscribe((response: any) => {
      this.trainingGroupTrainingFieldData = response[0];
      // Ensure updateReason is null after loading the data
      this.trainingGroupTrainingFieldData.updateReason = null;
        this.selectedTrainingTemplate = this.trainingGroupTrainingFieldData.templateId || this.trainingGroupTrainingFieldData.trainingTemplateId || null;
      this.selectedTemplateValue = this.selectedTrainingTemplate;
      this.appService.getTrainingByTrainingId(this.trainingGroupTrainingFieldData.trainingId,
        this.trainingGroupTrainingFieldData.version).subscribe((data: any) => {
          this.trainingGroupTrainingFieldData.trainingName = data[0].trainingName;
        })
      this.trainingGroupTrainingFieldData.escalate = this.trainingGroupTrainingFieldData.escalate === "Y";
      this.trainingGroupTrainingFieldData.repeatTraining = this.trainingGroupTrainingFieldData.repeatTraining === "Y";
      this.trainingGroupTrainingFieldData.allowToReviewResults = this.trainingGroupTrainingFieldData.allowToReviewResults === "Y";
      this.trainingGroupTrainingFieldData.showAnswersAtReview = this.trainingGroupTrainingFieldData.showAnswersAtReview === "Y";
      this.trainingGroupTrainingFieldData.overdueRmApprovalReqd = this.trainingGroupTrainingFieldData.overdueRmApprovalReqd === "Y";
      this.trainingGroupTrainingFieldData.overdueQaApprovalReqd = this.trainingGroupTrainingFieldData.overdueQaApprovalReqd === "Y";
      this.selectedLevelValue = this.trainingGroupTrainingFieldData.trainingLevel;

      if (this.trainingGroupTrainingFieldData.trainingLevel) {
        const matchingTrainingLevel = this.trainingLevelList?.find((item: any) => item == this.trainingGroupTrainingFieldData.trainingLevel);
        if (!matchingTrainingLevel) {
          this.oddTrainingLevel = this.trainingGroupTrainingFieldData.trainingLevel;
          this.trainingLevelDropdown.push({
            valueExp: this.trainingGroupTrainingFieldData.trainingLevel,
            displayExp: this.trainingGroupTrainingFieldData.trainingLevel
          })
        }
        this.selectedTrainingLevel = this.trainingGroupTrainingFieldData.trainingLevel;
      }

      if (this.trainingGroupTrainingFieldData.repeatIntervalUnit) {
        const matchingIntervalUnit = this.dropDownDataForRepeatIntervalUnit?.find((item: any) => item.codelistCode == this.trainingGroupTrainingFieldData.repeatIntervalUnit);
        if (!matchingIntervalUnit) {
          this.oddRepeatIntervalUnit = this.trainingGroupTrainingFieldData.repeatIntervalUnit;
          this.repeatIntervalUnitDropdown.push({
            valueExp: this.trainingGroupTrainingFieldData.repeatIntervalUnit,
            displayExp: this.trainingGroupTrainingFieldData.repeatIntervalUnit
          })
        }
        this.selectedRepeatIntervalUnit = this.trainingGroupTrainingFieldData.repeatIntervalUnit;
      }

      if (this.trainingGroupTrainingFieldData.listOfQaUsers != null) {
        this.selectedQaUsers = this.trainingGroupTrainingFieldData.listOfQaUsers.split(",").map(Number);
        setTimeout(() => { this.isListQAUsersSelected = this.qaUsersListDropdown.length == this.selectedQaUsers.length; })

      }
      this.isProcessing = false;
    })
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);

  }

  refreshGridData() {
    this.isProcessing = true;
    this.getcallMethod();
  }

  backToPreviousPage() {
    this.router.navigate(['dashboard/trainingGroups']);
  }

  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;
  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;

  addAndEditFunction(data: any) {
    this.isProcessing = true;

    if (this.operationFlag === 'ADD_MULTI') {
      this.isProcessing = false;
      this.addMultiTraining(data);
      return;
    }

    if (!this.isFormValid(data)) {
      this.fieldValidation();
      this.isProcessing = false;
      return;
    }

    const payload = this.createPayload(data);

    const apiRequest$ = this.operationFlag === 'ADD'
      ? this.appService.createTmsGroupTraining(payload)
      : this.appService.updateTmsGroupTraining(payload);

    apiRequest$.subscribe({
      next: (response: any) => this.handleSuccess(response),
      error: (error: any) => this.handleError(error)
    });
  }

  private isFormValid(data: any): boolean {
    if (!data.trainingId || !this.selectedLevelValue) return false;

    if (data.overdueQaApprovalReqd && this.selectedQaUsers.length < 1) return false;

    if (this.operationFlag === 'EDIT' && !data.updateReason) return false;

    return true;
  }

  private createPayload(data: any): any {
    const payload = {
      ...data,
      groupId: this.trainingGroupdata.groupId,
      trainingLevel: this.selectedLevelValue,
      escalate: data.escalate ? 'Y' : 'N',
      repeatTraining: data.repeatTraining ? 'Y' : 'N',
      allowToReviewResults: data.allowToReviewResults ? 'Y' : 'N',
      showAnswersAtReview: data.showAnswersAtReview ? 'Y' : 'N',
      overdueRmApprovalReqd: data.overdueRmApprovalReqd ? 'Y' : 'N',
      overdueQaApprovalReqd: data.overdueQaApprovalReqd ? 'Y' : 'N',
      listOfQaUsers: this.selectedQaUsers.map(String).join(','),
      repeatIntervalUnit: this.selectedRepeatIntervalUnit || null,
      templateId: this.selectedTrainingTemplate || null
    };

    if (this.operationFlag !== 'ADD') {
      delete payload.createdOn;
      delete payload.updatedOn;
    }

    return payload;
  }
  onEscalateChange() {
    if (!this.trainingGroupTrainingFieldData.escalate) {
      this.trainingGroupTrainingFieldData.escalateEveryNDays = null;
    }
  }

  onRepeatTrainingChange() {
    if (!this.trainingGroupTrainingFieldData.repeatTraining) {
      this.trainingGroupTrainingFieldData.repeatInterval = null;
      this.selectedRepeatIntervalUnit = null;
      this.trainingGroupTrainingFieldData.repeatIntervalUnit = null;
    }
  }

  onOverdueQaApprovalReqdChange() {
    if (!this.trainingGroupTrainingFieldData.overdueQaApprovalReqd) {
      this.selectedQaUsers = []; // Clear the multi-select array
      this.trainingGroupTrainingFieldData.listOfQaUsers = null;
    }
  }

  private handleSuccess(response: any) {
    this.displayMessage = response.result;
    this.displayResultType = response.resultType;
    this.isProcessing = false;

    if (response.resultType === 'S') {
      this.visibleAddAndEditPopup.close();
      this.getcallMethod();
    }

    this.showNotification(response);
  }

  private handleError(error: any) {
    this.displayMessage = error;
    this.displaySuccessMessage = false;
    this.displayErrorMessage = true;
    this.isProcessing = false;
    throw error;
  }

  private showNotification(response: any) {
    const isSuccess = response.resultType === 'S';

    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: 5000,
      data: {
        message: response.result,
        type: isSuccess ? 'Success' : 'Error',
        buttonLabel: "Ok",
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: isSuccess ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => sb.dismiss());
  }


  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteFiledValueRequiredMsg: any;
  deleteValidation() {
    this.deleteFiledValueRequiredMsg = document.getElementById('deleteTextarea-required-msg') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.isProcessing = false;
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    } else {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }

  deleteTrainingGroupGroupTrainingId: any;
  openDeletePopup(deleteRowData: any) {
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete Training Group";
    this.deleteTrainingGroupGroupTrainingId = deleteRowData.GROUP_TRAINING_ID;
    if (this.trainingGroupTrainingFieldData.deleteReason != undefined) {
      this.trainingGroupTrainingFieldData.deleteReason = '';
    }
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteTrainingGroupData: any;
  deleteFiledValue: any;
  deleteFunction() {
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteValidation();
      this.isProcessing = false;
    } else {
      this.deleteTrainingGroupData = {
        groupId: this.trainingGroupdata.groupId,
        groupTrainingId: this.deleteTrainingGroupGroupTrainingId,
        deleteReason: this.trainingGroupTrainingFieldData.deleteReason,
      };
      this.appService.deleteTmsGroupTraining(this.deleteTrainingGroupData).subscribe({
        next: (response: any) => {
          this.displayMessage = response.result;
          this.displayResultType = response.resultType;
          const isSuccess = response.resultType === 'S';

          if (isSuccess) {
            this.visibleDeletePopup.close();
            this.getcallMethod();
          }

          const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: response.result,
              type: isSuccess ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: isSuccess ? 'Success' : 'Error',
          });

          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        },
        error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }


  selectedQaUsers: any = [];
  qaUsersListDropdown: any = [];
  selectBoxForQaUsers() {
    for (const user of this.getListOfQaUsersList) {
      this.qaUsersListDropdown.push({
        valueExp: user.userId,
        displayExp: user.userName
      });
    }
  }

  getSelectedTrainingId: any;
  getSelectedTrainingName: string;
  getSelectedVersion: any;

  showUserSearchGrid: boolean;
  searchByTrainingName: any = null;
  searchByTrainingCode: any = null;
  searchByCategory: any = [];
  searchByLanguage: any = [];
  categoryValue: any;
  languageValue: any;
  searchTmsTrainingsVwDetails: any;
  getTmsTrainingDetailsTableData: any = [];

  searchTrainingFunction() {
    this.searchTrainingChildCheckBoxs = false;
    this.showUserSearchGrid = false;
    this.searchByTrainingName = null;
    this.searchByTrainingCode = null;
    this.multiUsersArray = [];
    this.categoryValue = null;
    this.languageValue = null;
    this.visibleSearchTrainingPopup = this.dialog.open(this.searchTraining, this.searchTrainingConfig);
  }

  searchTrainingGridDataFunction() {
    this.isProcessing = true;
    this.searchTmsTrainingsVwDetails = {
      trainingName: this.searchByTrainingName,
      trainingCode: this.searchByTrainingCode,
      category: this.categoryValue ? this.categoryValue : null,
      language: this.languageValue ? this.languageValue : null,
      groupId: this.trainingGroupdata.groupId,
      excludeExpiredTrainings: 'Y'
    };
    this.appService.searchTrainingsByCondition(this.searchTmsTrainingsVwDetails).subscribe((response: any) => {
      this.getTmsTrainingDetailsTableData = response;
      this.showUserSearchGrid = true;
      this.isProcessing = false;
    })
  }
  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }
  resetSearchTrainingGridDataFunction() {
    this.isProcessing = true;
    this.searchByTrainingName = null;
    this.searchByTrainingCode = null;
    this.categoryValue = null;
    this.languageValue = null;
    this.getTmsTrainingDetailsTableData = [];
    this.showUserSearchGrid = false;
    this.isProcessing = false;
  }
  categoryDropdown: any = [];
  languageDropdown: any = [];
  selectBoxeForCategory() {
    for (const category of this.dropDownForCategories) {
      this.categoryDropdown.push({
        valueExp: category.trainingCategoryCode,
        displayExp: category.trainingCategoryName
      });
    }
  }

  selectBoxeForLanguage() {
    for (const language of this.dropDownForLangauge) {
      this.languageDropdown.push({
        valueExp: language.codelistCode,
        displayExp: language.codelistName
      });
    }
  }

  trainingLevelList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
  selectedTrainingLevel: any = null;
  trainingLevelDropdown: any = [];
  selectedTrainingTemplate: any = null;
  trainingTemplateDropdown: any = [];


  selectedCategoryValue: any;
  selectedLanguageValue: any;
  selectedLevelValue: any;
  selectedTemplateValue: any;

  countrysearchTxt: any;
  countryFieldValue: any;

  categorysearchTxt: any;
  onCategorySelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.categoryValue = item.valueExp;
      }
    }
  }

  onCategorySelectOld(item: any) {
    this.selectedCategoryValue = item.valueExp;
  }
  onCategoryRemoved(item: any) { }

  languagesearchTxt: any;
  onLangaugeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.languageValue = item.valueExp;
      }
    }
  }

  onLangaugeSelectOld(item: any) {
    this.selectedLanguageValue = item.valueExp;
  }
  onLangaugeRemoved(item: any) { }


  trianingLevelsearchTxt: any;
  onLevelSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (item) {
          this.selectedLevelValue = item.valueExp;
        } else {
          this.selectedLevelValue = null;
        }
      } else {
        this.selectedLevelValue = undefined;
      }

    }
  }


  filteredQAUsersValue: any = [];
  trianingTemplatesearchTxt: any;


  onTemplateSelect(event: any, item: any) {
    if (!event.isUserInput) return;

    if (!event.source.selected) {
      this.selectedTemplateValue = undefined;
       this.selectedTrainingTemplate = null;
      return;
    }
    if (!item) {
      this.clearTemplateFields();
      return;
    }
    this.selectedTemplateValue = item.valueExp;
    const matchedTemplate = this.dropdownForTemplates.find((t: any) => t.templateId == this.selectedTemplateValue);

    if (matchedTemplate) {
      this.applyTemplateData(matchedTemplate);
    }
  }

  private applyTemplateData(template: any) {
    const target = this.trainingGroupTrainingFieldData;

    target.dueNDayFromAssigned = template.dueNDayFromAssigned;
    target.remindNDayBeforeDue = template.remindNDayBeforeDue;
    target.remindEveryNDays = template.remindEveryNDays;
    target.escalateEveryNDays = template.escalateEveryNDays;
    target.repeatInterval = template.repeatInterval;
    target.repeatIntervalUnit = template.repeatIntervalUnit;
    target.allowedFailedAttempts = template.allowedFailedAttempts;
    target.allowedFailedAttemptsAfterUnlock = template.allowedFailedAttemptsAfterUnlock;
    target.maxAllowedFailedAttempts = template.maxAllowedFailedAttempts;
    target.dueNDayFromOverdueUnlock = template.dueNDayFromOverdueUnlock;
    target.retakeAfterNMinOnFailedAttempt = template.retakeAfterNMinOnFailedAttempt;

    target.escalate = template.escalate === "Y";
    target.repeatTraining = template.repeatTraining === "Y";
    target.allowToReviewResults = template.allowToReviewResults === "Y";
    target.showAnswersAtReview = template.showAnswersAtReview === "Y";
    target.overdueRmApprovalReqd = template.overdueRmApprovalReqd === "Y";
    target.overdueQaApprovalReqd = template.overdueQaApprovalReqd === "Y";

    this.selectedRepeatIntervalUnit = null;
    if (template.repeatIntervalUnit) {
      const matchedUnit = this.repeatIntervalUnitDropdown.find((u: any) => u.valueExp == template.repeatIntervalUnit);
      if (matchedUnit) {
        this.selectedRepeatIntervalUnit = matchedUnit.valueExp;
        this.selectedRepeatIntervalUnitDisplayExp = matchedUnit.displayExp;
      }
    }

    this.selectedQaUsers = [];
    if (template.listOfQaUsers) {
      const users = template.listOfQaUsers.split(",");
      if (users.length > 0) {
        this.selectedQaUsers = users.map(Number);
        setTimeout(() => {
          this.isListQAUsersSelected = this.qaUsersListDropdown.length === this.selectedQaUsers.length;
        });
      }
    }
  }

  clearTemplateFields(): void {
    // Reset "odd" selection markers
    this.oddTrainingLevel = null;
    this.oddTrainingTemplate = null;
    this.oddRepeatIntervalUnit = null;

    // Reset training field data object properties
    const target = this.trainingGroupTrainingFieldData;
    target.trainingLevel = null;
    target.dueNDayFromAssigned = null;
    target.remindNDayBeforeDue = null;
    target.escalate = false;
    target.remindEveryNDays = null;
    target.escalateEveryNDays = null;
    target.repeatTraining = false;
    target.repeatInterval = null;
    target.repeatIntervalUnit = null;
    target.allowedFailedAttempts = null;
    target.allowedFailedAttemptsAfterUnlock = null;
    target.maxAllowedFailedAttempts = null;
    target.allowToReviewResults = false;
    target.showAnswersAtReview = false;
    target.overdueRmApprovalReqd = false;
    target.overdueQaApprovalReqd = false;
    target.listOfQaUsers = null;
    target.dueNDayFromOverdueUnlock = null;
    target.retakeAfterNMinOnFailedAttempt = null;

    // Reset dropdown and selection variables
    this.selectedRepeatIntervalUnit = null;
    this.selectedTrainingTemplate = null;
    this.selectedTrainingLevel = this.trainingLevelList[0];
    this.selectedLevelValue = 1;
    this.selectedRepeatIntervalUnitDisplayExp = null;
    this.selectedQaUsers = [];
  }

  activeInactiveLabel: string;
  activeInactiveButtonLabel: string;
  errorMsgContent: string;
  activeInactiveGroupId: number;
  activeInactiveuserId: number;
  groupUserActionFlag: boolean;
  openActiveAndInActivePopup(tmsGroupActiveInactiveRowData: any) {
    if (tmsGroupActiveInactiveRowData.IS_ACTIVE) {
      this.popupTitle = "Training Group Inactivation";
      this.activeInactiveLabel = "Reason for Inactivation";
      this.activeInactiveButtonLabel = "Inactivate";
      this.errorMsgContent = "Inactivation";
      this.groupUserActionFlag = false;
    } else {
      this.popupTitle = "Group Activation";
      this.activeInactiveLabel = "Reason for Activation";
      this.activeInactiveButtonLabel = "Activate";
      this.errorMsgContent = "Activation";
      this.groupUserActionFlag = true;
    }
    this.activeInactiveGroupId = tmsGroupActiveInactiveRowData.GROUP_TRAINING_ID;
    this.trainingGroupTrainingFieldData.groupActiveInactiveReason = "";
    this.visibleTrainingGroupActiveInactivePopup = this.dialog.open(this.trainingGroupActiveInactivePopup, this.trainingGroupActiveInactivePopupConfig);
  }

  cancelTmsGroupActiveInActiveFunction() {
    this.visibleTrainingGroupActiveInactivePopup.close();
  }

  groupActiveInactiveReasonValue: any;
  groupActiveInactiveReasonRequiredMsg: any;
  tmsGroupActiveInactiveValidation() {
    this.groupActiveInactiveReasonValue = document.getElementById('groupActiveInactiveReason') as HTMLInputElement;
    this.groupActiveInactiveReasonRequiredMsg = document.getElementById('groupActiveInactiveReason-required-msg') as HTMLInputElement;
    if (this.trainingGroupTrainingFieldData.groupActiveInactiveReason == "") {
      this.groupActiveInactiveReasonValue.style.border = '1px solid red';
      this.groupActiveInactiveReasonRequiredMsg.style.display = 'block';
    } else {
      this.groupActiveInactiveReasonValue.style.border = 'none';
      this.groupActiveInactiveReasonRequiredMsg.style.display = 'none';
    }
  }

  tmsGroupActiveInActiveFunction(trainingGroupUserFieldData: any) {
    this.isProcessing = true;
    if (this.trainingGroupTrainingFieldData.groupActiveInactiveReason == "") {
      this.tmsGroupActiveInactiveValidation();
      this.isProcessing = false;
    } else {
      const isActiveValue = this.groupUserActionFlag ? 'ACTIVATE' : 'INACTIVATE';
      let tmsGroupUserActiveInactiveData = {
        groupTrainingId: this.activeInactiveGroupId,
        isActive: isActiveValue,
        inActiveReason: this.trainingGroupTrainingFieldData.groupActiveInactiveReason,
      };
      this.appService.tmsGroupActiveInactive(tmsGroupUserActiveInactiveData).subscribe({
        next: (response: any) => {
          this.displayMessage = response.result;
          this.displayResultType = response.resultType;
          const isSuccess = response.resultType === 'S';

          if (isSuccess) {
            this.visibleTrainingGroupActiveInactivePopup.close();
            this.getcallMethod();
          }

          const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: response.result,
              type: isSuccess ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: isSuccess ? 'Success' : 'Error',
          });

          sb.onAction().subscribe(() => {
            sb.dismiss();
          });

          this.isProcessing = false;
        },
        error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.trainingGroupTrainingsDataForGrid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, trainingGroup: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : trainingGroup.GROUP_TRAINING_ID;
    this.auditTrail.gridName = 'GROUP_TRAININGS';
    this.auditTrail.groupId = this.trainingGroupdata.groupId;
    this.auditTrail.report_And_Popup_Name = 'Group Trainings Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(trainingGroup);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Group Trainings Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild('listQAUsers') listQAUsers: MatSelect;

  isListQAUsersSelected = false;
  toggleAllSelection(value: any) {
    if (value == 'listQAUsers') {
      if (this.isListQAUsersSelected) this.listQAUsers.options.forEach((item: MatOption) => item.select());
      else this.listQAUsers.options.forEach((item: MatOption) => item.deselect());
    }
  }
  listQAUsersSearchText: any;

  onlistQAUsersSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isListQAUsersSelected = this.qaUsersListDropdown.length == this.selectedQaUsers.length;
      })
    }
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };

  dynamicLabel: any = null;
  label: any = [];
  dynamicLabelCall() {
    this.isProcessing = true;
    const data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (response: any) => {
        this.label = response;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[user.columnName] = user.changedFieldName;
          return acc;
        }, {});

        this.isProcessing = false;
      },
      error: (error: any) => {
        this.isProcessing = false;
        console.error(error);
      }
    });
  }


  //multi training add
  searchTrainingParentCheckBox: boolean = false;
  searchTrainingChildCheckBoxs: boolean = false;
  searchTrainingChildCheckBoxsMenu: boolean = false;

  multiUsersArray: any = [];
  searchTrainingDataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.multiUsersArray = [];
      this.getTmsTrainingDetailsTableData.forEach((training: any) => {
        if (training.trainingName) {
          training.searchTrainingChildCheckBoxs = true; // Updated property
          this.multiUsersArray.push({ trainingId: training.trainingId, trainingName: training.trainingName, version: training.version });
        }
      });
      this.searchTrainingParentCheckBox = true;
    } else {
      this.multiUsersArray = [];
      this.getTmsTrainingDetailsTableData.forEach((training: any) => {
        if (training.trainingName) {
          training.searchTrainingChildCheckBoxs = false; // Updated property
        }
      });
      this.searchTrainingParentCheckBox = false;
    }
  }

  searchTrainingChildCheckBoxChecked(e: any, listOfTrainingsVwDetails: any, idx: any) {
    if (e.target.checked) {
      listOfTrainingsVwDetails.searchTrainingChildCheckBoxs = true;
      if (!this.multiUsersArray.some((storedUser: any) => storedUser.trainingId === listOfTrainingsVwDetails.trainingId)) {
        this.multiUsersArray.push({ trainingId: listOfTrainingsVwDetails.trainingId, trainingName: listOfTrainingsVwDetails.trainingName, version: listOfTrainingsVwDetails.version });
      }
      this.searchTrainingParentCheckBox = this.getTmsTrainingDetailsTableData.every((allUsers: any) => allUsers.searchTrainingChildCheckBoxs);
    } else {
      listOfTrainingsVwDetails.searchTrainingChildCheckBoxs = false;
      const removal = this.multiUsersArray.findIndex((storedUser: any) => storedUser.trainingId === listOfTrainingsVwDetails.trainingId);
      if (removal > -1) this.multiUsersArray.splice(removal, 1);
      this.searchTrainingParentCheckBox = this.getTmsTrainingDetailsTableData.every((allUsers: any) => allUsers.searchTrainingChildCheckBoxs);
    }
  }
  addTrainingNameFunction() {
    if (this.multiUsersArray.length > 20) {
      alert("A maximum of 20 trainings only can be assigned at once.");
    } else if (this.multiUsersArray.length > 0) {

      this.trainingGroupTrainingFieldData.trainingName = this.multiUsersArray.map((training: any) => training.trainingName).join(',');

      if (this.multiUsersArray.length === 1) {
        this.trainingGroupTrainingFieldData.trainingId = this.multiUsersArray[0].trainingId;
        this.trainingGroupTrainingFieldData.version = this.multiUsersArray[0].version;
        this.operationFlag = 'ADD';
      } else {
        this.operationFlag = 'ADD_MULTI';
        this.trainingGroupTrainingFieldData.trainingId = 'MULTI_SELECTION';
      }

      this.visibleSearchTrainingPopup.close();
    } else {
      this.visibleSearchTrainingPopup.close();
    }
  }
  cancelSearchTrainingFunction() {
    this.getSelectedTrainingId = null;
    this.getSelectedTrainingName = '';
    this.getSelectedVersion = null;
    this.visibleSearchTrainingPopup.close();
  }

  addMultiTraining(trainingGroupTrainingFieldData: any) {


    this.isProcessing = true;
    if (!trainingGroupTrainingFieldData.trainingName ||
      !this.selectedLevelValue ||
      (this.trainingGroupTrainingFieldData.overdueQaApprovalReqd && this.selectedQaUsers.length < 1)) {
      this.fieldValidation();
      this.isProcessing = false;
    } else {
      let completedRequests = 0;
      let totalRequests = this.multiUsersArray.length;
      let successCount = 0;

      this.multiUsersArray.forEach((training: any) => {
        this.trainingGroupTrainingFieldData.trainingId = training.trainingId;
        this.trainingGroupTrainingFieldData.version = training.version;

        const data = {
          ...this.trainingGroupTrainingFieldData,
          groupId: this.trainingGroupdata.groupId,
          trainingLevel: this.selectedLevelValue,
          escalate: this.trainingGroupTrainingFieldData.escalate ? 'Y' : 'N',
          repeatTraining: this.trainingGroupTrainingFieldData.repeatTraining ? 'Y' : 'N',
          allowToReviewResults: this.trainingGroupTrainingFieldData.allowToReviewResults ? 'Y' : 'N',
          showAnswersAtReview: this.trainingGroupTrainingFieldData.showAnswersAtReview ? 'Y' : 'N',
          overdueRmApprovalReqd: this.trainingGroupTrainingFieldData.overdueRmApprovalReqd ? 'Y' : 'N',
          overdueQaApprovalReqd: this.trainingGroupTrainingFieldData.overdueQaApprovalReqd ? 'Y' : 'N',
          listOfQaUsers: this.selectedQaUsers.map(String).join(','),
          repeatIntervalUnit: this.selectedRepeatIntervalUnit || null,
          templateId: this.selectedTrainingTemplate || null
        };

        this.appService.createTmsGroupTraining(data).subscribe({
          next: (Response: any) => {
            if (Response.resultType === 'S') {
              successCount++;
            }

            completedRequests++;

            // Only when all API calls are done
            if (completedRequests === totalRequests) {
              this.isProcessing = false;
              this.visibleAddAndEditPopup.close();
              this.getcallMethod();

              let resultType = 'Error';
              if (successCount === totalRequests) {
                resultType = 'Success';
              } else if (successCount > 0) {
                resultType = 'Partial';
              }
              const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                duration: 5000,
                data: {
                  message: `${successCount} of ${totalRequests} trainings created successfully.`,
                  type: resultType,
                  buttonLabel: "Ok",
                  pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
                },
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: successCount === totalRequests ? 'Success' : 'Error',
              });

              sb.onAction().subscribe(() => sb.dismiss());
            }
          },
          error: (error) => {
            completedRequests++;
            this.displayErrorMessage = true;

            if (completedRequests === totalRequests) {
              this.isProcessing = false;

              let resultType = 'Error';
              if (successCount === totalRequests) {
                resultType = 'Success';
              } else if (successCount > 0) {
                resultType = 'Partial';
              }
              const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                duration: 5000,
                data: {
                  message: `${successCount} of ${totalRequests} trainings created successfully.`,
                  type: resultType,
                  buttonLabel: "Ok",
                  pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
                },
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: successCount === totalRequests ? 'Success' : 'Error',
              });

              sb.onAction().subscribe(() => sb.dismiss());
            }

            throw error;
          }
        });
      });
    }
  }



  htmlContent: any;
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;

  getClobData(val: any) {
    this.isProcessing = true;
    this.htmlContent = val;
    this.editorComponent.openEditor(this.htmlContent, 'Training Name(s)');
    this.isProcessing = false;
  }

}
